export default IconStepOut => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-step-out" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 3l0 12" />
  <path d="M16 7l-4 -4" />
  <path d="M8 7l4 -4" />
  <path d="M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
</svg>`;